export const MandatoryParameters = {
  Suspension: ['Ride Height', 'Corner Weights', 'Total Weight', 'Cross Weight', 'Front Weight', 'Left Weight'],
  Tires: ['Tire ID', 'Tread Depth', 'Circumference', 'Tire Temperature'],
  Brakes: [],
  Drivetrain: ['Final Drive', 'Drop Gear', 'Gear Ratio 1', 'Gear Ratio 2', 'Gear Ratio 3', 'Gear Ratio 4', 'Gear Ratio 5', 'Gear Ratio 6', 'Gear Ratio 7', 'Gear Ratio 8', 'Drive Type', 'Number of Gears'],
  Engine: ['Power', 'Rev limit'],
  Electronics: [],
  Aero: [],
};

const ClubTrackDayImperial = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'inches', min: '0', max: '10', step: '0.01', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-6', max: '2', step: '0.05', isFourCornerGroup: true },
      { name: 'Toe', unit: 'inches', min: '-1', max: '1', step: '0.01', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'lb/in', min: '0', max: '2000', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'lbs', min: '0', max: '1500', step: '1', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'lbs', min: '40', max: '10000', step: '1' },
      { name: 'Cross weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°F', min: '68', max: '284', step: '1', colorThresholds: { cold: '104', warm: '140', hot: '176', tooHot: '212', ridiculouslyHot: '248' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'gallons', min: '0', max: '50', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const ClubTrackDayMetric = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'mm', min: '0', max: '1000', step: '0.5', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-5', max: '5', step: '0.1', isFourCornerGroup: true },
      { name: 'Toe', unit: 'mm', min: '-10', max: '10', step: '0.5', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'N/mm', min: '0', max: '200', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'kg', min: '0', max: '680', step: '0.5', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'kg', min: '40', max: '4000', step: '0.5' },
      { name: 'Cross Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left Weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°C', min: '20', max: '140', step: '1', colorThresholds: { cold: '40', warm: '60', hot: '80', tooHot: '100', ridiculouslyHot: '120' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'L', min: '0', max: '200', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const GT4TCRImperial = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'inches', min: '0', max: '10', step: '0.01', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-6', max: '2', step: '0.05', isFourCornerGroup: true },
      { name: 'Toe', unit: 'inches', min: '-1', max: '1', step: '0.01', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'lb/in', min: '0', max: '2000', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Dampers: [
      { name: 'Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'lbs', min: '0', max: '1500', step: '1', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'lbs', min: '40', max: '10000', step: '1' },
      { name: 'Cross weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°F', min: '68', max: '284', step: '1', colorThresholds: { cold: '104', warm: '140', hot: '176', tooHot: '212', ridiculouslyHot: '248' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'gallons', min: '0', max: '50', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [
      { name: 'ABS Map', unit: '', min: '0', max: '20', step: '1' },
      { name: 'TC Map', unit: '', min: '0', max: '20', step: '1' },
    ],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const GT4TCRMetric = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'mm', min: '0', max: '1000', step: '0.5', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-5', max: '5', step: '0.1', isFourCornerGroup: true },
      { name: 'Toe', unit: 'mm', min: '-10', max: '10', step: '0.5', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'N/mm', min: '0', max: '200', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Dampers: [
      { name: 'Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'kg', min: '0', max: '680', step: '0.5', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'kg', min: '40', max: '4000', step: '0.5' },
      { name: 'Cross Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left Weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°C', min: '20', max: '140', step: '1', colorThresholds: { cold: '40', warm: '60', hot: '80', tooHot: '100', ridiculouslyHot: '120' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [
      { name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' },
      { name: 'Pad Compound', unit: 'text', isFrontRearGroup: true },
    ],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'L', min: '0', max: '200', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [
      { name: 'ABS Map', unit: '', min: '0', max: '20', step: '1' },
      { name: 'TC Map', unit: '', min: '0', max: '20', step: '1' },
    ],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const GT3RacecarImperial = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'inches', min: '0', max: '10', step: '0.01', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-6', max: '2', step: '0.05', isFourCornerGroup: true },
      { name: 'Toe', unit: 'inches', min: '-1', max: '1', step: '0.01', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'lb/in', min: '0', max: '2000', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    BumpRubbers: [
      { name: 'Packers', unit: '', min: '0', max: '20', step: '1', isFourCornerGroup: true },
      { name: 'Packer Thickness', unit: 'mm', min: '0', max: '5', step: '1', isFourCornerGroup: true },
      { name: 'Bump Rubber Gap', unit: 'mm', min: '0', max: '40', step: '1', isFourCornerGroup: true },
    ],
    Dampers: [
      { name: 'Low Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Low Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'lbs', min: '0', max: '1500', step: '1', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'lbs', min: '40', max: '10000', step: '1' },
      { name: 'Cross weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°F', min: '68', max: '284', step: '1', colorThresholds: { cold: '104', warm: '140', hot: '176', tooHot: '212', ridiculouslyHot: '248' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [
      { name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' },
      { name: 'Pad Compound', unit: 'text', isFrontRearGroup: true },
      { name: 'Master Cylinder Size', unit: 'mm', min: '0', max: '40', step: '1', isFrontRearGroup: true },
    ],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
    Differential: [
      { name: 'Preload', unit: 'lb-ft', min: '0', max: '500', step: '1' },
      { name: 'Friction Faces', unit: '', min: '0', max: '16', step: '1' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'gallons', min: '0', max: '50', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [
      { name: 'ABS Map', unit: '', min: '0', max: '25', step: '1' },
      { name: 'TC Map', unit: '', min: '0', max: '25', step: '1' },
    ],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const GT3RacecarMetric = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'mm', min: '0', max: '1000', step: '0.5', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-5', max: '5', step: '0.1', isFourCornerGroup: true },
      { name: 'Toe', unit: 'mm', min: '-10', max: '10', step: '0.5', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'N/mm', min: '0', max: '200', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    BumpRubbers: [
      { name: 'Packers', unit: '', min: '0', max: '20', step: '1', isFourCornerGroup: true },
      { name: 'Packer Thickness', unit: 'mm', min: '0', max: '5', step: '1', isFourCornerGroup: true },
      { name: 'Bump Rubber Gap', unit: 'mm', min: '0', max: '40', step: '1', isFourCornerGroup: true },
    ],
    Dampers: [
      { name: 'Low Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Low Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'kg', min: '0', max: '680', step: '0.5', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'kg', min: '40', max: '4000', step: '0.5' },
      { name: 'Cross Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left Weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°C', min: '20', max: '140', step: '1', colorThresholds: { cold: '40', warm: '60', hot: '80', tooHot: '100', ridiculouslyHot: '120' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
    Differential: [
      { name: 'Preload', unit: 'lb-ft', min: '0', max: '500', step: '1' },
      { name: 'Friction Faces', unit: '', min: '0', max: '16', step: '1' },
    ],
  },
  Engine: [
    { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
    { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    { name: 'Fuel Level', unit: 'L', min: '0', max: '200', step: '0.5' },
  ],
  Electronics: {
    Maps: [
      { name: 'ABS Map', unit: '', min: '0', max: '25', step: '1' },
      { name: 'TC Map', unit: '', min: '0', max: '25', step: '1' },
    ],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const OpenWheelImperial = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'inches', min: '0', max: '10', step: '0.01', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-6', max: '2', step: '0.05', isFourCornerGroup: true },
      { name: 'Toe', unit: 'inches', min: '-1', max: '1', step: '0.01', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'lb/in', min: '0', max: '2000', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    BumpRubbers: [
      { name: 'Packers', unit: '', min: '0', max: '20', step: '1', isFourCornerGroup: true },
      { name: 'Packer Thickness', unit: 'mm', min: '0', max: '5', step: '1', isFourCornerGroup: true },
      { name: 'Bump Rubber Gap', unit: 'mm', min: '0', max: '40', step: '1', isFourCornerGroup: true },
    ],
    Dampers: [
      { name: 'Low Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Low Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'lbs', min: '0', max: '1500', step: '1', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'lbs', min: '40', max: '10000', step: '1' },
      { name: 'Cross weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°F', min: '68', max: '284', step: '1', colorThresholds: { cold: '104', warm: '140', hot: '176', tooHot: '212', ridiculouslyHot: '248' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [
      { name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' },
      { name: 'Pad Compound', unit: 'text', isFrontRearGroup: true },
      { name: 'Master Cylinder Size', unit: 'mm', min: '0', max: '40', step: '1', isFrontRearGroup: true },
    ],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
    Differential: [
      { name: 'Preload', unit: 'lb-ft', min: '0', max: '500', step: '1' },
      { name: 'Friction Faces', unit: '', min: '0', max: '16', step: '1' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'gallons', min: '0', max: '50', step: '0.5' },
    ],
  },
  Electronics: [
    { name: 'ABS Map', unit: '', min: '0', max: '25', step: '1' },
    { name: 'TC Map', unit: '', min: '0', max: '25', step: '1' },
  ],
  Aero: [
    { name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2', isFrontRearGroup: true },
  ],
};

const OpenWheelMetric = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'mm', min: '0', max: '1000', step: '0.5', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-5', max: '5', step: '0.1', isFourCornerGroup: true },
      { name: 'Toe', unit: 'mm', min: '-10', max: '10', step: '0.5', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'N/mm', min: '0', max: '200', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    BumpRubbers: [
      { name: 'Packers', unit: '', min: '0', max: '20', step: '1', isFourCornerGroup: true },
      { name: 'Packer Thickness', unit: 'mm', min: '0', max: '5', step: '1', isFourCornerGroup: true },
      { name: 'Bump Rubber Gap', unit: 'mm', min: '0', max: '40', step: '1', isFourCornerGroup: true },
    ],
    Dampers: [
      { name: 'Low Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Compression', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'Low Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
      { name: 'High Speed Rebound', unit: '', min: '0', max: '50', step: '1', isFourCornerGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'kg', min: '0', max: '680', step: '0.5', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'kg', min: '40', max: '4000', step: '0.5' },
      { name: 'Cross Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left Weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°C', min: '20', max: '140', step: '1', colorThresholds: { cold: '40', warm: '60', hot: '80', tooHot: '100', ridiculouslyHot: '120' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
    Differential: [
      { name: 'Preload', unit: 'lb-ft', min: '0', max: '500', step: '1' },
      { name: 'Friction Faces', unit: '', min: '0', max: '16', step: '1' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'L', min: '0', max: '200', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [
      { name: 'ABS Map', unit: '', min: '0', max: '25', step: '1' },
      { name: 'TC Map', unit: '', min: '0', max: '25', step: '1' },
    ],
  },
  Aero: {
    Wings: [
      { name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2', isFrontRearGroup: true },
    ],
  },
};

const TimeAttackImperial = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'inches', min: '0', max: '10', step: '0.01', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-6', max: '2', step: '0.05', isFourCornerGroup: true },
      { name: 'Toe', unit: 'inches', min: '-1', max: '1', step: '0.01', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'lb/in', min: '0', max: '2000', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'lbs', min: '0', max: '1500', step: '1', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'lbs', min: '40', max: '10000', step: '1' },
      { name: 'Cross weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'psi', min: '10', max: '50', step: '0.2', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°F', min: '68', max: '284', step: '1', colorThresholds: { cold: '104', warm: '140', hot: '176', tooHot: '212', ridiculouslyHot: '248' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'gallons', min: '0', max: '50', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

const TimeAttackMetric = {
  Suspension: {
    Alignment: [
      { name: 'Ride Height', unit: 'mm', min: '0', max: '1000', step: '0.5', isFourCornerGroup: true },
      { name: 'Camber', unit: 'degrees', min: '-5', max: '5', step: '0.1', isFourCornerGroup: true },
      { name: 'Toe', unit: 'mm', min: '-10', max: '10', step: '0.5', isFourCornerGroup: true },
    ],
    Springs: [
      { name: 'Spring Rate', unit: 'N/mm', min: '0', max: '200', step: '10', isFourCornerGroup: true },
      { name: 'ARB Setting', unit: '', min: '0', max: '100', step: '1', isFrontRearGroup: true },
    ],
    Weights: [
      { name: 'Corner Weights', unit: 'kg', min: '0', max: '680', step: '0.5', isFourCornerGroup: true },
      { name: 'Total Weight', unit: 'kg', min: '40', max: '4000', step: '0.5' },
      { name: 'Cross Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Front Weight', unit: '%', min: '40', max: '60', step: '0.1' },
      { name: 'Left Weight', unit: '%', min: '40', max: '60', step: '0.1' },
    ],
  },
  Tires: {
    Pressures: [
      { name: 'Cold Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
      { name: 'Hot Tire Pressure', unit: 'bar', min: '0.7', max: '3.5', step: '0.01', isFourCornerGroup: true },
    ],
    Temperature: [
      { name: 'Tire Temperature', unit: '°C', min: '20', max: '140', step: '1', colorThresholds: { cold: '40', warm: '60', hot: '80', tooHot: '100', ridiculouslyHot: '120' } },
    ],
    Details: [
      { name: 'Tire ID', unit: 'text', type: 'select', isFourCornerGroup: true },
      { name: 'Tread Depth', unit: 'mm', min: '0', max: '20', step: '0.1', isFourCornerGroup: true },
      { name: 'Circumference', unit: 'mm', min: '1000', max: '3000', step: '1', isFrontRearGroup: true },
    ],
  },
  Brakes: {
    Brakes: [{ name: 'Brake Balance', unit: '%', min: '0', max: '100', step: '0.1' }],
  },
  Drivetrain: {
    Gearing: [
      { name: 'Final Drive', unit: '', min: '2', max: '12', step: '0.001' },
      { name: 'Drop Gear', unit: '', min: '0.5', max: '6', step: '0.001' },
      { name: 'Gear Ratio 1', unit: '', min: '1', max: '12', step: '0.001' },
      { name: 'Gear Ratio 2', unit: '', min: '1', max: '6', step: '0.001' },
      { name: 'Gear Ratio 3', unit: '', min: '0.8', max: '4', step: '0.001' },
      { name: 'Gear Ratio 4', unit: '', min: '0.5', max: '2.5', step: '0.001' },
      { name: 'Gear Ratio 5', unit: '', min: '0.5', max: '2', step: '0.001' },
      { name: 'Gear Ratio 6', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 7', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Gear Ratio 8', unit: '', min: '0.5', max: '1.5', step: '0.001' },
      { name: 'Drive Type', unit: 'text', type: 'select', options: ['RWD', 'FWD', 'AWD'], value: 'RWD' },
      { name: 'Number of Gears', unit: '', type: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8'], value: '6' },
    ],
  },
  Engine: {
    Power: [
      { name: 'Power', unit: 'hp', min: '100', max: '4000', step: '10' },
      { name: 'Rev limit', unit: 'rpm', min: '2000', max: '22000', step: '50' },
    ],
    Fuel: [
      { name: 'Fuel Level', unit: 'L', min: '0', max: '200', step: '0.5' },
    ],
  },
  Electronics: {
    Maps: [],
  },
  Aero: {
    Wings: [{ name: 'Wing Angle', unit: 'degrees', min: '-5', max: '20', step: '0.2' }],
  },
};

export const CarTemplates = {
  'Club Track Day': {
    Imperial: ClubTrackDayImperial,
    Metric: ClubTrackDayMetric
  },
  'GT4 / TCR': {
    Imperial: GT4TCRImperial,
    Metric: GT4TCRMetric
  },
  'GT3 Racecar': {
    Imperial: GT3RacecarImperial,
    Metric: GT3RacecarMetric
  },
  'Open Wheel': {
    Imperial: OpenWheelImperial,
    Metric: OpenWheelMetric
  },
  'Time Attack': {
    Imperial: TimeAttackImperial,
    Metric: TimeAttackMetric
  }
};







